/* eslint-disable */

import React, { useCallback, useMemo, useState } from "react";
import { Button, ModalDialog, StringField, Success } from "@culturehq/components";

import { errorService, Trans } from "app/utils";
import getSubdomain from "app/utils/getSubdomain";
import ChqModalDialog from "components/common/ChqModalDialog";

const StoryCopyLink = ({
  children, isPrompt, storyQuestion, onClose: onCloseMenu, parentPromptId
}) => {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const path = useMemo(() => {
    if (!storyQuestion) {
      return "new/stories/create";
    }

    if (parentPromptId || storyQuestion.parentStoryQuestion) {
      return `stories/trend/${parentPromptId || storyQuestion.parentStoryQuestion.id}/prompt/${storyQuestion.id}`
    }

    return `stories/trend/${storyQuestion.id}`
  }, [parentPromptId, storyQuestion]);

  const link = useMemo(() => {
    const baseUrl = `https://${getSubdomain()}.culturehq.com/${path}`;
    if (isPrompt) return `${baseUrl}#create`;
  
    return baseUrl;
  }, [isPrompt, path]);

  const onCopy = useCallback(
    () => {
      if (open) {
        document.querySelector("#url").select();
        document.execCommand("copy");
        setCopied(true);
      } else {
        navigator.clipboard.writeText(link)
          .then(() => setCopied(true))
          .catch(err => errorService.error(`Failed to copy: ${err}`));
      }
    },
    [open, setCopied]
  );

  const onOpen = useCallback(() => {
    setOpen(true);
    setTimeout(onCopy, 0);
  }, [onCopy, setOpen]);

  const onClose = useCallback(
    () => {
      setCopied(false);
      setOpen(false);
      if (onCloseMenu) {
        onCloseMenu();
      }
    },
    [onCloseMenu, setCopied, setOpen]
  );

  return (
    <>
      {children(onOpen)}
      {open && (
        <ChqModalDialog onClose={onClose} className="survey-share" trigger={children}>
          <ModalDialog.Heading onClose={onClose}>
            <Trans>Share</Trans>
          </ModalDialog.Heading>
          <ModalDialog.Body>
            <p>
              <Trans>
                Below is a direct link to the story that you can share with
                your colleagues.
              </Trans>
            </p>
            <StringField
              readOnly
              name="url"
              value={link}
            />
            {copied && (
              <Success>
                <Trans>Direct link copied to the clipboard.</Trans>
              </Success>
            )}
          </ModalDialog.Body>
          <ModalDialog.Footer>
            <div>
              <Button inverted onClick={onClose}>
                <Trans>Close</Trans>
              </Button>
            </div>
            <div>
              <Button primary onClick={onCopy}>
                <Trans>Copy</Trans>
              </Button>
            </div>
          </ModalDialog.Footer>
        </ChqModalDialog>
      )}
    </>
  );
};

export default StoryCopyLink;
